import { createContext, useContext } from "react";

/** True when a page body is rendered as a tab inside another page, so its PageHeader should be a sub-heading. */
export const EmbeddedPageContext = createContext(false);

export const useEmbeddedPage = () => useContext(EmbeddedPageContext);
